module.exports = {
      id: "Tw-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Tw-usage",
      toString: function () {
        return this.url;
      }
    }